import React, { useRef } from "react";

export default function UseRef() {
  const inputRender = useRef();
  const startFocus = () => {
    inputRender.current.focus();
  };

  return (
    <div>
      <p style={{ textAlign: "left" }}>
        <b>
          Refs are similar to State but unlike state Refs won't cause the
          component to Re-render. useRef returns an object like{" "}
          {"{current: default_value}"}
        </b>{" "}
        <br />
        Refs are not only useful for accessing DOM elements but can also be used
        to persist values between renders without causing re-render. <br />
        In class components, we can use class variables to persist value between
        renders but In functional components, we need to use Refs, if we are not
        using State. <br />
        In General, Refs can also be used to reference the JSX elements. That
        is, the below input filed is attached to Ref when we click on the focus
        button the foucs will come to that input field without casuing Re-render
        the entire component. That is best use-case.
      </p>
      <p style={{ textAlign: "left", color: "red" }}>
        Warning: We should not use the useRef to update the values such updating
        the input field with a some value Since it won't update the state of
        that particular variable.
      </p>
      <input
        ref={inputRender}
        style={{ marginBottom: "10px" }}
        type="text"
        className="form-control"
      />
      <button className="btn btn-primary" onClick={startFocus}>
        Focus
      </button>
    </div>
  );
}









<div id="hubspotForm"><div class="submitted-message hs-main-font-element hs-form-cfa6c34e-18d6-4d57-b51b-7a1c209429b7 hs-form-cfa6c34e-18d6-4d57-b51b-7a1c209429b7_e7a0ba18-854d-4d4b-a6fc-4f5aa51cef8f" data-reactid=".hbspt-forms-0"><p style="
    color: white;
">Thanks for submitting the form. Someone from Bandura Cyber will be reaching out!</p></div></div>